import React, { useState } from 'react';
import { connect } from 'shalala';
import { withRouter } from 'react-router-dom';
import { Button, Col, Row } from 'react-bootstrap';

import PagoManager from './PagoManager';
import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import Backdrop from '../../../../facturotopia/backdrop/Backdrop';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';
import ReceptorSelection from '../../create/components/ReceptorSelection';
import PagosTotalesCalculator from '../../support/pagos/PagosTotalesCalculator';
import PagosImpuestosCalculator from '../../support/pagos/PagosImpuestosCalculator';
import FactorajeFinancieroRequest from '../../support/factoraje/FactorajeFinancieroRequest';
import ComprobanteRequestInputTransformer from '../../transformers/ComprobanteRequestInputTransformer';

const Pagos = (props) => {
  const { input } = props;

  const [state, setState] = useState({
    isValid: false,
    data: props.data || {},
    receptorManualInfo: false,
  });

  const handleOnStampingRequest = async () => {
    const pagos = FactorajeFinancieroRequest.make(state.data.Pago).apply();

    const tmpPago = new PagosImpuestosCalculator(pagos).apply().get();

    const totales = new PagosTotalesCalculator(tmpPago).apply();

    let body = new ComprobanteRequestInputTransformer().make({
      ...input,
      TipoDeComprobante: 'Pago',
      Complemento: {
        Pagos: {
          Version: '2.0',
          Pago: tmpPago,
          Totales: totales,
        },
      },
    });

    body = {
      ...body,
      Metadata: {
        ...body.Metadata,
        Syvasa: [
          {
            FactorajeFinanciero: 'portal',
          },
        ],
      },
    };

    setState({
      ...state,
      busy: true,
    });

    try {
      const response = await Http.post(`api/comprobantes`, body);

      setState({
        ...state,
        result: response,
      });
    } catch (error) {
      setState({
        ...state,
        error: error.data || error,
      });
    }
  };

  const handleOnChange = (event, isValid) => {
    setState({
      ...state,
      data: {
        ...state.data,
        ...event,
      },
      isValid,
    });
  };

  const handleOnReceptorManualInputForm = (value) => {
    setState({
      ...state,
      receptorManualInfo: value,
    });
  };

  const handleOnReceptorFormChange = (event) => {
    props.onChange(event);
  };

  const handleDownload = (uuid) => {
    const params = {
      type: 'zip',
      as: 'link',
    };

    Http.get(`${window.BONJOUR_URL}/api/comprobantes/${uuid}/download`, { params })
      .then(
        (response) => {
          window.location = response.data.link;
        },
        (error) => {
          window.ToastManager.show({
            variant: 'error',
            title: 'Error',
            message: error.message || 'No fue posible descargar tu factura. =(',
          });
        }
      )
      .finally(() => {
        handleOnAction('success');
      });
  };

  const handleOnAction = (action) => {
    if (action === 'reset') {
      setState({
        ...state,
        error: undefined,
        result: undefined,
      });

      return;
    }

    if (action === 'success') {
      props.listActions.setListData(state.result.data);
    }

    props.history.push(`/app/comprobantes/${props.uuid}/info`);
  };

  const renderError = () => {
    const { error } = state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={() => {
            handleOnAction('reset');
          }}
        />
      </div>
    );
  };

  const renderResult = () => {
    const { result } = state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida"
          result={result}
          extra={
            <>
              <Button
                type="button"
                variant="secondary"
                className="mr-3"
                onClick={() => {
                  handleDownload(result.data.uuid);
                }}
              >
                Descargar
              </Button>

              <Button
                type="button"
                onClick={() => {
                  handleOnAction('success');
                }}
              >
                Continuar
              </Button>
            </>
          }
        />
      </div>
    );
  };

  const { receptorManualInfo, busy, isValid, data, error, result } = state;

  const passes = !isValid && !!input.Receptor?.rfc;

  return (
    <>
      {!!error && renderError()}

      {!!result && renderResult()}

      <Row>
        <Col
          sm="12"
          md="6"
          className={receptorManualInfo ? 'z-index-top' : 'pb-2'}
        >
          <div>
            <strong className="text-upper">Receptor</strong>
          </div>

          <div className="mt-2">
            <ReceptorSelection
              autoFocus
              data={input}
              datos_fiscales_requeridos={true}
              onManualInfoRequest={handleOnReceptorManualInputForm}
              onFormDataChange={handleOnReceptorFormChange}
            />
          </div>
        </Col>
      </Row>

      {!!receptorManualInfo && <Backdrop />}

      <PagoManager
        data={data}
        input={input}
        onChange={handleOnChange}
      />

      <div className="mt-3">
        <LoadingButton
          loading={busy}
          disabled={!passes || busy}
          onClick={handleOnStampingRequest}
        >
          {busy ? 'Procesando...' : 'Crear factura'}
        </LoadingButton>
      </div>
    </>
  );
};

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(withRouter(Pagos));
